export const skill = {
    labels: {
        skill: "Skill",
        skills: "Skills",
        skills_group: "Skills - Categories",
        skills_edit: "Skills - Edit Category",
        categories: "Categories",
        category: "Category",
    },
    placeholders: {
    },
    modals: {
        titles: {
            skill_add: "Add Skill",
            skill_del: "Delete Skill",
            category_add: "Add Category",
            category_del: "Delete Category",
        },
        messages: {
            category_del: "Are you sure you want to remove the category <strong>{name}</strong>?<br/>This will remove all skills in this group.",
            skill_del: "Are you sure you want to remove the skill <strong>{name}</strong>?<br/>This action cannot be undone!",
        },
    },
    texts: {
    },
};
